const permissions = {
  listDivision: 'MB009',
  addDivision: 'MB010',
  editDivision: 'MB011',
  deleteDivision: 'MB012'
};

export default permissions;
